<template>
  <v-app>
    <v-app-bar
      :fixed="screen >= 500 ? true : false"
      :height="screen >= 500 ? '80px' : '60px'"
      :color="$store.state.socio.cor"
    >
      <v-img
        class="logo"
        :src="$vuetify.theme.primary ? $store.state.socio.logo : '../../assets/Marca_Globus_negativa.png'"
        contain
        height="60px"
      ></v-img>
    </v-app-bar>
    <v-main style="margin-top: 5rem">
      <v-overlay
        :absolute="$store.state.absoluteLoader"
        :value="$store.state.loader"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-overlay>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "internal",
  data() {
    return {
      screen: window.innerWidth,
    };
  },
};
</script>

<style scoped>
@media (min-width: 490px) {
  .logo {
    display: none !important;
  }
}
</style>
